import { render, staticRenderFns } from "./BanmanagerList.vue?vue&type=template&id=1edf6d10&"
import script from "./BanmanagerList.vue?vue&type=script&lang=js&"
export * from "./BanmanagerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports